import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ReMultiselectModule } from '@common/re-multiselect/re-multiselect.module';
import { GoogleAddressModule } from '@directive/google-address/google-address.module';
import { ReorderPipeModule } from '@pipes/reorder-pipe/reorder.module';
import { ListingPrimeNgModule } from '../../my-listings/listing-primeNg.module';
import { AddLeadsComponent } from './add-leads.component';
import { ReMultipleSelectModule } from '@common/re-multi-select/re-multiselect.module';
import { CheckboxModule } from 'primeng/checkbox';
import { PipeDirectiveModule } from '@shared-modules/pipe-directive.module';
import { MobileFormatPipeModule } from '@pipes/mobile-format/mobile-format.module';
import { PossibleDuplicateContactModule } from '@modules/contact/possible-duplicate-contact/possible-duplicate-contact.module';

@NgModule({
  declarations: [AddLeadsComponent],
  imports: [
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    ListingPrimeNgModule,
    ReMultiselectModule,
    ReMultipleSelectModule,
    ReorderPipeModule,
    GoogleAddressModule,
    CheckboxModule,
    PipeDirectiveModule,
    MobileFormatPipeModule,
    PossibleDuplicateContactModule,
  ],
  exports: [AddLeadsComponent],
})
export class AddLeadModule {}
